module.exports = __webpack_public_path__ + "img/h05-min.21c266c2.png";